import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex, ListItem, Box } from "@chakra-ui/react";
import { Flag } from "@airhelp/flags";
export const LanguageSwitcherListItem = ({ item, onItemClick, isActive }) => (_jsx(ListItem, { color: isActive ? "primary.900" : "greyscale.600", _hover: {
        md: {
            textDecoration: "none",
            backgroundColor: "greyscale.200",
            color: "primary.900",
        },
    }, onClick: () => onItemClick(item), cursor: "pointer", bg: isActive ? "greyscale.300" : "initial", borderRadius: "md", p: 3, my: "px", transition: ".3s", "data-testid": isActive && "languageSwitcherListItemActive", children: _jsxs(Flex, { align: "center", "data-testid": item.id, children: [_jsx(Flag, { code: item.icon, size: "xs" }), _jsx(Box, { ml: 3, fontSize: "md", fontWeight: "normal", children: item.name })] }) }));
